import { render, staticRenderFns } from "./YbtPayOrderCopy.vue?vue&type=template&id=946206de&scoped=true"
import script from "./YbtPayOrderCopy.vue?vue&type=script&lang=js"
export * from "./YbtPayOrderCopy.vue?vue&type=script&lang=js"
import style0 from "./YbtPayOrderCopy.vue?vue&type=style&index=0&id=946206de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946206de",
  null
  
)

export default component.exports